<template>
    <div class="goodDetail">
        <div class="bg1">123</div>
        <div class="goodCont">
            <div class="tohome">当前位置：<span style="cursor:pointer" @click="toHome">首页</span>＞<span>商品详情</span></div>
            <div class="goodInfo">
                <div class="leftInfo">
                    <img :src="goodDetail.img" alt="">
                </div>
                <div class="rightInfo">
                    <div class="goodName">
                        {{ goodDetail.name }}
                    </div>
                    <div class="goodSpec">
                        生产厂家：{{ goodDetail.comm }}
                    </div>
                    <div class="goodSpec">
                        规格：{{ goodDetail.spec }}
                    </div>
                    <div class="goodSpec">
                        {{ goodDetail.wh}}
                    </div>
                    <div class="goodInst">
                        {{ goodDetail.instructions}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            goodList: [
                { id: 1, img: require("@imgs/1.jpg"), name: '盐酸苯环壬酯片（飞赛乐）', spec: '2mg*2片', comm: '北京华素制药股份有限公司', wh: '【批准文号】国药准字H10970083', instructions: '【功能主治】用于预防晕车、晕船及晕机。' },
                { id: 2, img: require("@imgs/3.jpg"), name: '西地碘含片(华素片)', spec: '1.5mg*15片', comm: '北京华素制药股份有限公司', wh: '【批准文号】国药准字H10910012', instructions: '【适应症/功能主治】 用于慢性咽喉炎、口腔溃疡、慢性牙龈炎、牙周炎。' },
                { id: 3, img: require("@imgs/4.jpg"), name: '联苯苄唑乳膏(孚琪)', spec: '15g:150mg', comm: '北京华素制药股份有限公司', wh: '【批准文号】国药准字H10930043', instructions: '【适应症】用于手癣、足癣、体癣、股癣、花斑癣及念珠性外阴阴道炎。' },
                { id: 4, img: require("@imgs/5.jpg"), name: '猴耳环消炎片(薄膜衣)', spec: '0.24g*100片', comm: '北京华素制药股份有限公司', wh: '【批准文号】国药准字Z44020149', instructions: '【适应症/功能主治】清热解毒，凉血消肿，止泻。用于上呼吸道感染，急性咽喉炎，急性扁桃体炎，急性胃肠炎，亦可用于细菌性痢疾。' },
            ],
            id: '',
            goodDetail: {}
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            var goodList = this.goodList.filter(v => {
                return v.id == this.id;
            });
            this.goodDetail = goodList[0];
        }
        console.log(this.goodDetail)
    },
    methods: {
        toHome() {
            this.$router.push('/')
        }
    }
}
</script>

<style lang="scss" scoped>
.goodDetail {
    .bg1 {
        width: 195px;
        height: 50px;
    }

    .goodCont {
        width: 1200px;
        margin: 0 auto;
        margin-top: 30px;
        min-height: 449px;

        .tohome {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            text-align: left;
        }

        .goodInfo{
            display: flex;
            margin-top: 40px;
            .leftInfo{
                width: 200px;
                height: 200px;
                margin-right: 20px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .rightInfo{
                text-align: left;
                .goodName{
                    font-size: 24px;
                    font-weight: bold;
                }
                .goodSpec{
                    font-size: 14px;
                    color: #4d4d4d;
                    margin-top: 10px;
                }
                .goodInst{
                    font-size: 18px;
                    color: #4d4d4d;
                    margin-top: 20px;
                }
            }
        }
    }
}
</style>